import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  selectorResponse: {},
  selectorType: '',
};

const productSelector = createSlice({
  name: 'userData',
  initialState: { ...initialState },
  reducers: {
    setProducSelctorData: (state, action: PayloadAction<any>) => ({ ...state, selectorResponse: action.payload }),
    resetProductSelector: state => ({ ...state, ...initialState }),
    setProductSelectorType: (state, action: PayloadAction<any>) => ({ ...state, selectorType: action.payload }),
  },
});

export const { setProducSelctorData, resetProductSelector, setProductSelectorType } = productSelector.actions;
export default productSelector.reducer;
